module.exports = __webpack_public_path__ + "static/img/bg-fr.08d76473.png";